<template>
  <select
    :value="value"
    class="dimension-unit"
    @change="$emit('input', $event.target.value)"
  >
    <option v-for="unit in units" :key="unit" :value="unit">
      {{ unit }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "in"
    }
  },
  data() {
    return {
      units: ["in", "ft", "mm", "m"]
    };
  }
};
</script>

<style scoped>
select.dimension-unit {
  display: inline-block !important;
  width: 50px !important;
}
</style>
